import { useThree } from '@react-three/fiber';
import { useMemo, useState } from 'react';
import * as THREE from 'three';

export function useMaterial({
  style,
  color = '#ffffff',
  roughness = 0.5,
  metalness = 0,
  rx = 1,
  ry = 1,
  lineWidth = 100,
  size = 1024
}) {
  const isMobile = false;
  const { gl } = useThree();
  const [anisotropy] = useState(gl.capabilities.getMaxAnisotropy());
  const [canvas] = useState(document.createElement('canvas'));

  const texture = useMemo(() => {
    if (style === -1) return null;

    let _size = size;
    let _lineWidth = lineWidth;

    if (isMobile) {
      _size = size / 8;
      _lineWidth = lineWidth / 8;
    }
    canvas.width = _size;
    canvas.height = _size;

    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);

    if (style === 0) {
      ctx.fillStyle = '#ffffff';
      ctx.strokeStyle = 'none';
      // ctx.fillRect(0, 0, size, size);
      // ctx.strokeStyle = "#000000";
      ctx.lineWidth = _lineWidth;
      ctx.moveTo(0, 0);
      ctx.lineTo(size / 2, 0);
      ctx.lineTo(size / 2, size);
      ctx.lineTo(0, size);

      ctx.fill();
    } else if (style === 1) {
      ctx.fillStyle = 'none';
      ctx.lineStyle = '#ff0099';
      ctx.lineWidth = _lineWidth;

      for (var i = 0; i < 10; i++) {
        ctx.moveTo((i / 5) * size, 0);
        ctx.lineTo((i / 5) * size - size, size);
        ctx.stroke();
      }
    }

    document.body.appendChild(canvas);

    const t = new THREE.CanvasTexture(canvas);
    t.wrapS = t.wrapT = THREE.MirroredRepeatWrapping;
    t.repeat.set(rx, ry);
    t.encoding = THREE.sRGBEncoding;
    t.anisotropy = anisotropy;

    return t;
  }, [style, size, lineWidth, isMobile, canvas, rx, ry, anisotropy]);

  const material = useMemo(() => {
    let m;

    // const light = new THREE.DirectionalLight(0xffffff);
    // light.position.set(0.5, 0.5, 1);
    // scene.add(light);

    // const ambientLight = new THREE.AmbientLight(0x080808);
    // scene.add(ambientLight);

    // function createShaderMaterial(shader, light, ambientLight) {
    //   const u = THREE.UniformsUtils.clone(shader.uniforms);

    //   const vs = shader.vertexShader;
    //   const fs = shader.fragmentShader;

    //   const material = new THREE.ShaderMaterial({
    //     uniforms: u,
    //     vertexShader: vs,
    //     fragmentShader: fs,
    //   });

    //   material.uniforms["uDirLightPos"].value = light.position;
    //   material.uniforms["uDirLightColor"].value = light.color;

    //   material.uniforms["uAmbientLightColor"].value = ambientLight.color;

    //   return material;
    // }

    // m = createShaderMaterial(ToonShaderDotted, light, ambientLight);
    m = new THREE.MeshStandardMaterial({
      // color: 0xffffff,
      // map: texture,
      // roughness,
      metalness: 0.9,
      roughness: 0.8,
      // opacity: 1,
      // reflectivity: 1,
      // ior: 1.5,
      // transmission: 1,
      // envMapIntensity: 2.5,
      side: THREE.DoubleSide,
      // vertexColors: true,
      // transparent: true,
      toneMapped: true
      // wireframe: true,
    });

    if (texture) m.map = texture;

    return m;
  }, [texture]);

  return material;
}
